
import { computed, defineComponent, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { clsEstimateCond } from '@/types/clsEstimateCond';
import { clsEstimateData } from '@/types/clsEstimateData';
import OrderAreaTbl from '@/components/OrderAreaTbl.vue';
import { app } from '../main';
import { distribute_way } from '../BizTerms';

export default defineComponent({
  components: { OrderAreaTbl },
  props: ['user'],
  setup(props) {
    const router = useRouter()
    if(!props.user.login) {
      console.log('Can\'t access Order for not login.')
      router.back()
    }
    const payment = 'invoice'
    let EstimateCond = new clsEstimateCond('nokina','B4')
    const econd = sessionStorage.getItem('estimateCond')
    if(!econd) throw new Error('Order: econd undefined.')
    EstimateCond = JSON.parse(econd)
    
    let EstimateData = new clsEstimateData()
    const estdata = sessionStorage.getItem('estimateData')
    if(!estdata) throw new Error('Order: estdata undefined.')
    EstimateData = JSON.parse(estdata)
    
    let area_list: string[] = []
    const areas = sessionStorage.getItem('areas')
    if(!areas) throw new Error('Order: areas undefined.')
    area_list = JSON.parse(areas)
    
    const message = reactive({
      msg: '',
      err: false,
      clear() {
        this.msg = '';
        this.err = false;
      },
    })
    const comment = ref('')
    const back = () => {
      router.back()
    }
    const order = () => {
      if(comment.value == '') {
        app.config.globalProperties.$notify({
          title: 'Warning',
          message: '納品予定日を入力してください。',
          type: 'warning'
        })
      }else {
        let json = {
          'cond'		:EstimateCond,
          'estimate':EstimateData,
          'areas'		:area_list,
          'csrf'		:props.user.csrf,
          'comment'	:comment.value
        };
        //console.log(JSON.stringify(json));
        const api_path = app.config.globalProperties.api_path
        fetch(api_path + 'ajax/order.php', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(json)
        })
        .then(response => response.json())
        .then(json => {
          //console.log(json);
          if(json['result'] == 'failure') {
            throw new Error(json.error)
          }
          message.clear()
          router.push('/thanks?order_id=' + json['order_id'])
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
      }
    }

    return {
      payment,
      EstimateCond,
      EstimateData,
      message,
      comment,
      back,
      order,
      area_list,
      distribute_way,
    }
  }
})
